// Why checkout has no destination, when it has none. Each state has one sentence,
// used as Place Order's disabled reason as-is; the shipping card adds a full stop
// and, where there is something to do, the way to do it.

// The states, in the order Checkout tells them apart.
//   noneEligible — #403: the shopper HAS locations, but none the API accepts as a
//                  destination (Pending, Rejected, Suspended or otherwise unusable).
//                  One sentence for every reason, because checkout can't tell them
//                  apart honestly.
//   loadFailed   — GET /locations failed before any list arrived: say so, offer Retry.
//   noLocations  — the list loaded, and it is empty.
//   loading      — the list has not arrived yet.
export type ShippingLocationGap =
    | "noneEligible"
    | "loadFailed"
    | "noLocations"
    | "loading";

export const SHIPPING_LOCATION_GAP_COPY: Record<ShippingLocationGap, string> = {
    noneEligible: "None of your locations can receive orders right now",
    loadFailed: "We couldn't load your shipping locations",
    noLocations: "You don't have a shipping location yet",
    loading: "Loading your shipping locations…",
};
